import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'
import { authSelector, lobSelector, employeeSelector } from './../../../selectors'
import { lobAction } from './../../../actions/'
import CustomTable from '../../../components/table'
import { employeeAction } from '../../../actions/employee'


const header = ['Start Date', 'LOB ID', 'LOB Name', 'Modified By']

class ListLOB extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lobs: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.lobList(access_token)
    this.props.getEmployeeList(access_token)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lobData) {
      this.setState({ lobs: nextProps.lobData })
    }
  }

  handleClickEdit(id) {
    this.props.handleClickEdit(true, id)
    this.props.handleSpan(true)
  }

  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser)) window.location = '/home'

    return (
      /* eslint no-underscore-dangle: 0 */
      <CustomTable
        header={ header }
        data={ this.props.LOBs }
        handleClickEdit={ this.handleClickEdit }
        span={ get(this.props, 'span') }
        table={ this.props.table }
        employeeList={ this.props.employeeList }
      />
    )
  }
}

ListLOB.propTypes = {
  lobList: PropTypes.func.isRequired,
  lobData: PropTypes.array.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  getEmployeeList: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  lobData: lobSelector.getListLOB,
  lobDeactivate: lobSelector.getDeactivateLOBData,
  redirectLOB: lobSelector.redirectLOB,
  employeeList: employeeSelector.getListUser,
  authData: authSelector.getAuth,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  lobList: lobAction.getLOB,
  deactivateLOB: lobAction.deactivateLOB,
  resetDeactivateLOB: lobAction.resetDeactivateLOB,
  resetListLOB: lobAction.resetListLOB,
  getEmployeeList: employeeAction.getUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListLOB)



// WEBPACK FOOTER //
// ./src/pages/lob/list/index.js